<script>
import moment from 'moment'
import { mixin as clickaway } from 'vue-clickaway'
import filtersField from '@/components/services/ui/filtersField.vue'
import {
  RexCheckboxesGroup,
  RexSelect,
  RexDate
} from '@/components/views/rexFieldsV2'

export default {
  name: 'events-filters',
  components: {
    filtersField,
    RexCheckboxesGroup,
    RexSelect,
    RexDate
  },
  mixins: [
    clickaway
  ],
  data: () => ({
    types: [
      {
        name: 'Рекламные туры',
        slug: 1
      },
      {
        name: 'Вебинары',
        slug: 2
      },
      {
        name: 'Мероприятие',
        slug: 3
      }
    ],
    quickFilterButton: {
      isShow: false,
      offsetTop: 0,
    }
  }),
  computed: {
    filtersCollection() {
      return this.$store.getters['events/getFiltersCollection']
    },
    isFilters() {
      return this.$store.getters['events/isControls']
    },
    getDaysWithEvents() {
      return this.filtersCollection.date.map(item => moment.unix(item).toDate())
    },
  },
  methods: {
    openEditModal() {
      const isBitrixUsersLoaded = Boolean(this.$store.getters['events/getResponsibleUsers'].length)

      if (!isBitrixUsersLoaded) {
        this.$store.commit('events/updateEditFormModal', {
          isLoading: true
        })

        this.$store.dispatch('events/getResponsibleUsers')
      }

      this.$store.commit('events/updateEditFormModal', {
        active: true,
        isNew: true
      })
    },
    getMinDatepickerDate() {
      const minAvailableDate = 1483221599000

      return moment(minAvailableDate).toDate()
    },
    hideQuickFilterButton() {
      this.quickFilterButton = {
        isShow: false,
        offsetTop: 0
      }
    },
    formChangeHandler({ element: { offsetTop } }) {
      const additionalTopOffset = 12

      this.quickFilterButton = {
        isShow: true,
        offsetTop: offsetTop + additionalTopOffset
      }

      this.$store.commit('events/setIsLoadingMoreBlocked', true)
    },
    filter() {
      this.$store.commit('events/setCollection', [])
      this.$store.commit('events/setIsLoading', true)
      this.$store.commit('events/setIsLoadingMoreBlocked', false)

      this.$store.dispatch('events/getCollection', {
        ...this.$store.getters['events/getSearchForm'],
        page: 1,
        perPage: 10
      })

      this.hideQuickFilterButton()
    }
  }
}
</script>
<template>
  <div
    v-on-clickaway="hideQuickFilterButton"
    class="events-filters rex-sidebar"
  >
    <b-button
      v-if="quickFilterButton.isShow"
      type="is-primary"
      :style="{
        'top':`${quickFilterButton.offsetTop}px`
      }"
      class="
        rex-button2
        search-content__filters-quickfilter
        search-content__filters-quickfilter--left
      "
      @click="filter"
    >
      Применить
    </b-button>
    <b-loading
      v-if="!isFilters"
      :is-full-page="false"
      :active="!isFilters"
    />
    <div
      v-else
    >
      <filters-field
        label="Показывать"
        :common-style="true"
      >
        <rex-checkboxes-group
          name="eventsFiltersTypes"
          store-module="events"
          target="form.filters.types"
          :options="types"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        label="Дата проведения"
        :common-style="true"
      >
        <rex-date
          name="eventFiltersDates"
          store-module="events"
          target="form.filters"
          position="is-bottom-left"
          :range-targets="['dateFrom', 'dateTo']"
          :min-date="getMinDatepickerDate()"
          :events="getDaysWithEvents"
          :is-range="true"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        label="Город отправления/проведения"
        :common-style="true"
      >
        <rex-select
          name="eventFiltersLocations"
          store-module="events"
          target="form.filters.locations"
          :options="filtersCollection.locations"
          :hide-if-empty="false"
          @change="formChangeHandler"
        />
      </filters-field>
      <b-button
        class="rex-button2"
        type="is-primary"
        expanded
        @click="filter"
      >
        Фильтровать
      </b-button>
      <b-button
        class="rex-button2"
        type="is-primary"
        outlined
        expanded
        @click="openEditModal"
      >
        Создать
      </b-button>
    </div>
  </div>
</template>
